export const urls = {
  Landing: "/hello",
  Search: "/search",
  Cart: "/cart",
  AnnouncementsList: "/announcements",
};
